import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import type { RegionRepository } from '@/Domain/repositories/RegionRepository';
import type { Region } from '@/modules/region/domain/Region';
import { createHttpRegionesListRepository } from '@/modules/region/infrastructure/HttpRegionRepository';

import { store } from '../..';

const FETCH_REGIONS = 'region/fetchRegions';

export const fetchRegions = createAsyncThunk(FETCH_REGIONS, async () => {
  const regionRepository = createHttpRegionesListRepository();
  const regions = await regionRepository.getAll();
  return regions;
});

interface InitialState {
  data: Region[];
  isLoading: boolean;
}

const initialState: InitialState = {
  data: [],
  isLoading: false
};

const RegionSlice = createSlice({
  name: 'region',
  initialState,
  reducers: {},
  extraReducers: (builder) =>
    builder
      .addCase(fetchRegions.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchRegions.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
});

export const regionsRepository: RegionRepository = {
  getAll: async () => {
    const { region } = store.getState();
    return region.data;
  }
};

export const regionReducer = RegionSlice.reducer;
